import ICommand from "./ICommand";
import {useAppDispatch} from "../hooks";
import {setMessages} from "../redux/messages";
import {setPlayingChess} from "../redux/chess";

export const useClsCommand = (): ICommand => {
  const dispatch = useAppDispatch()

  return {
    help(): string {
      return '- cls\t\t\t\t\t:: clears the screen';
    },

    async process(msg: string): Promise<void> {
      dispatch(setMessages([]))
      dispatch(setPlayingChess(false))
    },

    matches(msg: string): boolean {
      return ['cls'].includes(msg.toLowerCase().trim())
    }
  };
}